import { useCallback } from 'react'
import { updateLoadingState } from '@sales-center/common'
import {
  toggleCustomFieldEnabled,
  toggleCustomFieldRequired,
} from '@user/store/customFieldSettings'
import { useAppDispatch } from '@user/store/hooks'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { ENTITY_TYPES } from '@sales-center/common'

interface Props {
  settingItem: ICustomFieldFormSetting
  customSettings: ICustomFieldFormSetting[]
  entityType: ENTITY_TYPES
}

export function useCustomSettingsCardHandlers(props: Props) {
  const { settingItem, customSettings, entityType } = props
  const { customFieldId: id } = settingItem
  const dispatch = useAppDispatch()
  const entityTypeNumber: number = entityType === ENTITY_TYPES.Lead ? 0 : 1

  const onChangeRequired = useCallback(async () => {
    dispatch(updateLoadingState('visible'))
    const field = customSettings.find((x) => x.customFieldId === id)
    if (field && !field.enabled && !field.required)
      await dispatch(
        toggleCustomFieldEnabled({
          id: id,
          entityType: entityTypeNumber,
          toggleState: true,
        }),
      )
    await dispatch(
      toggleCustomFieldRequired({
        id: id,
        entityType: entityTypeNumber,
        toggleState: !field?.required,
      }),
    )
    dispatch(updateLoadingState('hidden'))
  }, [dispatch, id, customSettings, entityTypeNumber])

  const onChangeEnabled = useCallback(async () => {
    dispatch(updateLoadingState('visible'))
    const field = customSettings.find((x) => x.customFieldId === id)
    if (field && field.enabled && field.required)
      await dispatch(
        toggleCustomFieldRequired({
          id: id,
          entityType: entityTypeNumber,
          toggleState: false,
        }),
      )
    await dispatch(
      toggleCustomFieldEnabled({
        id: id,
        entityType: entityTypeNumber,
        toggleState: !field?.enabled,
      }),
    )
    dispatch(updateLoadingState('hidden'))
  }, [dispatch, id, customSettings, entityTypeNumber])

  return {
    onChangeRequired,
    onChangeEnabled,
  }
}
